import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 52E3C504-34AB-4EE5-954F-768B1044B2A6
 * name send-circle
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-circle.svg
 * tags
 */
export const SendCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M8,7.71V11.05L15.14,12L8,12.95V16.29L18,12L8,7.71Z" /></>, 'SendCircleIcon');
export default SendCircleIcon